import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import PromoteForm from './components/PromoteForm/PromoteForm';
function EmployeePromoteForm(props: any) {
  const { onClose, open, getData, lastPromotedDate, latestPosition } = props;
  const DialogWrapper = styled(Dialog)(
    () => `
            .MuiDialog-container {
                height: 100vh;
            }
            
            .MuiDialog-paperScrollPaper {
                max-height: calc(100vh - 80px)
            }
        `
  );

  const handleClose = () => {
    onClose();
  };

  return (
    <DialogWrapper
      open={open}
      keepMounted
      maxWidth="sm"
      fullWidth
      scroll="paper"
      onClose={handleClose}
    >
      <PromoteForm
        getData={getData}
        handleClose={handleClose}
        empId={props.employeeId}
        lastPromotedDate={lastPromotedDate}
        latestPosition={latestPosition}
      />
    </DialogWrapper>
  );
}

EmployeePromoteForm.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  employeeId: PropTypes.string.isRequired,
  getData: PropTypes.any,
  lastPromotedDate: PropTypes.string,
  latestPosition: PropTypes.string
};

export default EmployeePromoteForm;
